import React, { useEffect, useRef } from 'react';

function Riegos({ onBackgroundImageCheck }) {
    const sectionRef = useRef(null);

    useEffect(() => {
        const sectionElement = sectionRef.current;
        const style = window.getComputedStyle(sectionElement);
        const hasBackgroundImage = style.backgroundImage !== 'none';
        onBackgroundImageCheck(hasBackgroundImage);
    }, [onBackgroundImageCheck]);

    const contenido = (
        <>
            <h1 className='display-4 fw-bold text-white'>Riegos</h1>
            <p className='lead text-white' style={{ textShadow: '0 0 5px rgba(0,0,0,0.5)' }}>
                Instalamos sistemas de riegos logrando un máximo de aprovechabilidad del área para una mayor economía de agua y energía.
            </p>
        </>
    );

    const contenidoMobile = (
        <>
            <h1 className='text-dark fs-2 fw-bold mb-3'>Riegos</h1>
            <p className='text-dark fs-5'>
                Instalamos sistemas de riegos logrando un máximo de aprovechabilidad del área para una mayor economía de agua y energía.
            </p>
        </>
    );

    const slides = ['imgriego', 'imgriego2', 'imgriego3'];

    return (
        <>
            <div id='carouselriegos' className='carousel slide w-100 carousel-fade' data-bs-ride='carousel'>
                <div className='carousel-inner'>
                    {slides.map((imgId, idx) => (
                        <div className={`carousel-item ${idx === 0 ? 'active' : ''} w-100`} key={imgId}>
                            <div className='d-flex w-100 d-block col-12 col-md-5 position-relative' id={imgId} ref={sectionRef}>
                                <div className='position-absolute w-100 h-100'></div>

                                {/* Escritorio */}
                                <div className='row align-self-center w-100 d-none d-md-flex' id='alineardescripcion'>
                                    <div className='col-12 col-md-6'>
                                        {contenido}
                                    </div>
                                    <div className='col-md-6'></div>
                                </div>
                            </div>

                            {/* Mobile */}
                            <div className='container d-block d-md-none mt-3 p-4 bg-light rounded shadow-sm'>
                                <div className='row'>
                                    <div className='col-12'>
                                        {contenidoMobile}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Botones de navegación */}
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselriegos" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselriegos" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </>
    );
}

export default Riegos;
